"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Filtered = function Filtered(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 16.999 19.001"
  }, _react["default"].createElement("g", {
    id: "Grupo_1223",
    "data-name": "Grupo 1223",
    transform: "translate(-1326.001 -449)"
  }, _react["default"].createElement("path", {
    id: "Subtração_1",
    "data-name": "Subtração 1",
    d: "M8262.006-9905a.881.881,0,0,1-.626-.26l-1.789-1.788a.878.878,0,0,1-.257-.737V-9913h-.027l-5.118-6.562a.871.871,0,0,1-.182-.646.885.885,0,0,1,.333-.6.926.926,0,0,1,.551-.2H8264a4.015,4.015,0,0,0,2.323,3.633l-3.407,4.368h-.027v7a.855.855,0,0,1-.257.739A.881.881,0,0,1,8262.006-9905Z",
    transform: "translate(-6928 10373)",
    fill: "#4b6f85"
  }), _react["default"].createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: "3",
    cy: "3",
    r: "3",
    transform: "translate(1337 449)",
    fill: "#dc3545"
  })));
};

Filtered.displayName = 'Filtered';
var _default = Filtered;
exports["default"] = _default;